import React, { useEffect, useState } from "react";
import {
  Box,
  FormButtonStyled,
  HeadingStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import { t } from "i18next";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import AuthApi from "../../../../services/api/authApi";
import { toast } from "react-toastify";
import PhoneInputField from "../../../../components/common/inputFields/PhoneInput";

const PhoneSignin1 = ({ handleSteps, handleSendOtp, setPhone }) => {
  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm();
  const phoneNum = watch("phone_number");

  const [loading, setLoading] = useState(false);

  const onSubmit = async (phone) => {
    try {
      setLoading(true);
      const response = await AuthApi.loginWithPhone(phone);

      if (response.code === 200) {
        if (response.data) {
          handleSendOtp();
        } else {
          toast.error(response.message);
        }
      } 
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
    }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPhone(phoneNum)
  }, [phoneNum])

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Box className="mb-4">
        <HeadingStyled size="24px" weight="bold" color="var(--text)">
          {t("wellcome_back")}
        </HeadingStyled>
        <TextStyled size="16px" color="var(--text2)">
          {t("please_enter_phone_num_for_otp")}
        </TextStyled>
      </Box>
      <Box>
        <Box>
          <PhoneInputField
            name="phone_number"
            label={"phone"}
            placeholder={"phonePlaceholder"}
            register={register}
            control={control}
            errors={errors}
            validationRules={{
              required: true,
            }}
            className={"mb-3 combined flex-wrap p-0"}
            bg="var(--white)"
          />
          <FormButtonStyled
            label={t("send_otp")}
            color="var(--white)"
            bg="var(--themeColor)"
            className="w-100"
            clName="w-100 my-4"
            type={"submit"}
            isLoading={loading}
          />
        </Box>
      </Box>
    </Form>
  );
};

export default PhoneSignin1;
